import { Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import React from "react"

type TagWithAdornmentProps = {
  color?: "primary" | "secondary" | "success" | "warning" | "critical"
  label: string
  className?: string
  endAdornment?: React.ReactElement<any>
}

const TagWithAdornment = ({
  color = "primary",
  label,
  className,
  endAdornment,
}: TagWithAdornmentProps) => {
  return (
    <Typography
      variant="subtitle2"
      className={clsx(
        "!flex h-4.5 items-center justify-center gap-1.5 rounded-lg text-center",
        className,
        {
          "!text-critical-600 bg-critical-50 px-2": color === "critical",
        },
        {
          "!text-primary-600 bg-primary-50 px-2": color === "primary",
        },
        {
          "!text-success-600 bg-success-50 px-2": color === "success",
        },
        {
          "!text-warning-600 bg-warning-50 px-2": color === "warning",
        },
        {
          "!text-secondary-600 bg-secondary-50 px-2": color === "secondary",
        }
      )}
    >
      <span>{label}</span>
      {endAdornment}
    </Typography>
  )
}

export default TagWithAdornment
